import { createI18n } from 'vue-i18n';
import fr from './assets/lang/fr';
import en from './assets/lang/en';

const i18n = createI18n({
  legacy: false, // nécessaire pour pouvoir utiliser useI18n()
  locale: 'fr', // langue par défaut
  //fallbackLocale: 'en',
  messages: {
    fr,
    en,
  },
});

export default i18n;
